import React from 'react';
import './Comparison.css';

const Comparison: React.FC = () => {
  return (
    <section className="comparison-section">
      <div className="comparison-header">
        <h2 className="comparison-title">
          Долгие поиски, устаревшие отчёты —<br />
          <span className="comparison-gradient">или datacircle?</span>
        </h2>
        <p className="comparison-subtitle">
          Традиционные обзоры рынка быстро теряют актуальность и не дают нужной глубины. С datacircle наши Клиенты получают обновлённые данные, которые наши аналитики находят в самых труднодоступных источниках и проверяют с помощью технологий AI.
        </p>
      </div>
      <div className="comparison-grid">
        <div className="comparison-column">
          <h3 className="column-title">без datacircle</h3>
          <ul className="comparison-list">
            <li className="comparison-item without-item">
              Разовые («на дату»), быстро устаревающие отчёты
            </li>
            <li className="comparison-item without-item">
              Типовые, шаблонные отчёты кадровых агентств, не учитывающие сложную специфику запроса и быстро теряющие актуальность
            </li>
            <li className="comparison-item without-item">
              Отсутствие информации по труднодоступным сегментам рынка
            </li>
            <li className="comparison-item without-item">
              Отсутствие возможности получения данных за пределами РФ юрисдикции
            </li>
            <li className="comparison-item without-item">
              Расхождения в методологиях и сложность сведения данных, полученных из разных источников
            </li>
            <li className="comparison-item without-item">
              Высокий риск ошибок при ручной работе с данными
            </li>
            <li className="comparison-item without-item">
              Догадки о компенсациях топ-менеджеров и управленцев среднего звена вместо точных цифр
            </li>
            <li className="comparison-item without-item">
              Работа с многочисленными агентствами и частными консультантами, использующими непрозрачные методологии получения данных
            </li>
          </ul>
        </div>
        <div className="comparison-column with-compindex">
          <h3 className="column-title">с datacircle</h3>
          <ul className="comparison-list">
            <li className="comparison-item with-item">
              Ежеквартальные обновления данных платформы
            </li>
            <li className="comparison-item with-item">
              Кастомизированные отчёты и дашборды, точно адаптированные под уникальный запрос нашего Клиента — с учётом географии, отраслей, ролей, структур компаний выборки и необходимых метрик
            </li>
            <li className="comparison-item with-item">
              Труднодоступные данные по компенсациям и льготам, собранные нашей командой отраслевых экспертов и аналитиков
            </li>
            <li className="comparison-item with-item">
              Широкий набор инструментов команды экспертов и аналитиков для получения данных за пределами РФ: сеть международных партнеров, база данных кандидатов за пределами РФ, партнерские AI-платформы
            </li>
            <li className="comparison-item with-item">
              Регламентированная методология сбора данных и автоматизированная валидация
            </li>
            <li className="comparison-item with-item">
              AI-модели для поиска аномалий и скрытых тенденций
            </li>
            <li className="comparison-item with-item">
              Прозрачные бенчмарки по ключевым ролям и отраслям
            </li>
            <li className="comparison-item with-item">
              White glove сервис и консультационная поддержка опытных экспертов и аналитиков
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
